
import { Vue } from "vue-class-component";

export default class Withdraw extends Vue {}
